import { Link } from '@inertiajs/react'
import logoTopbar from '../assets/brand/logo-topbar.svg'
import ProfileMenu from './ProfileMenu'

type CurrentUser = {
  id: number
  name: string
  email: string
  role: string
  initials: string | null
  photo_url: string | null
}

type Props = {
  currentUser: CurrentUser
}

export default function TopBar({ currentUser }: Props) {
  return (
    <header className="bg-ink">
      <div className="mx-auto flex w-full max-w-[1440px] items-center justify-between gap-4 px-5 py-4 md:px-10 md:py-5">
        <Link href="/" className="shrink-0">
          <img src={logoTopbar} alt="Exhibition Intelligence" className="h-8 w-auto" />
        </Link>

        <ProfileMenu
          name={currentUser.name}
          email={currentUser.email}
          role={currentUser.role}
          initials={currentUser.initials}
          photoUrl={currentUser.photo_url}
        />
      </div>
    </header>
  )
}
